import * as crypto from 'crypto-js';

import { formatDate } from "@angular/common";
import { Component, OnInit } from '@angular/core';


@Component({
	selector: 'app-proceedings25',
	templateUrl: './proceedings.component.html',
	styleUrls: ['./proceedings.component.css']
})
export class ProceedingsComponent25 implements OnInit {
	
	constructor() {}

	ngOnInit(): void {}
	
}